import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const PaymentSystemButtonStyles = styled.div<{
  disabled: boolean;
}>`
  margin: 10px 0 0;

  .apple-pay-button {
    ${({ disabled }) =>
      disabled &&
      `
    pointer-events: none;
    opacity: 0.5;
    `}
  }
`;

export const MessageStyles = styled(UiTypography)`
  margin: 10px 0 0;
  display: flex;
  align-items: center;

  ion-spinner {
    margin-left: 8px;
    flex-shrink: 0;
    color: inherit;
    width: 20px;
    height: 20px;
  }
`;
